import {
    LIST_RESULT_MODALITIES,
    LIST_RESULT_MODALITIES_SUCCESS,
    LIST_RESULT_MODALITIES_ERROR,
    ADD_RESULT_MODALITIES,
    SAVE_RESULT_MODALITIES,
    SAVE_RESULT_MODALITIES_SUCCESS,
    SAVE_RESULT_MODALITIES_ERROR,
    EDIT_RESULT_MODALITIES,
    UPDATE_RESULT_MODALITIES,
    UPDATE_RESULT_MODALITIES_SUCCESS,
    UPDATE_RESULT_MODALITIES_ERROR,
    DELETE_RESULT_MODALITIES,
    DELETE_RESULT_MODALITIES_SUCCESS,
    DELETE_RESULT_MODALITIES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    resultModalities: null,
    error: null,
    loading: false,
    resultModalitySelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_RESULT_MODALITIES:
            return {
                ...state,
                loading: true
            }
        case LIST_RESULT_MODALITIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_RESULT_MODALITIES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                resultModalities: action.payload
            }
        case SAVE_RESULT_MODALITIES:
        case DELETE_RESULT_MODALITIES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_RESULT_MODALITIES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_RESULT_MODALITIES_ERROR:
        case UPDATE_RESULT_MODALITIES_ERROR:
        case DELETE_RESULT_MODALITIES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_RESULT_MODALITIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                resultModalities: [...state.resultModalities, action.payload]
            }
        case ADD_RESULT_MODALITIES:
            return {
                ...state,
                resultModalitySelected: null,
                isEdit: false
            }
        case EDIT_RESULT_MODALITIES:
            return {
                ...state,
                resultModalitySelected: action.payload,
                isEdit: true
            }
        case UPDATE_RESULT_MODALITIES_SUCCESS:
        case DELETE_RESULT_MODALITIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                resultModalities: state.resultModalities.map(resultModality => 
                    resultModality.id === action.payload.id ? resultModality = action.payload : resultModality
                ),
                resultModalitySelected: null
            }
        // case DELETE_RESULT_MODALITIES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         resultModalities: state.resultModalities.filter( resultModality => resultModality.id !== action.payload)
        //     }
        default:
            return state;
    }
}